import { Bell, Menu, Moon, PanelLeft, Search, Sun, User } from 'lucide-react'
import { Button } from './ui/button'
import { useAuthStore, useThemeStore, useUIStore } from '@/stores'
import { cn } from '@/utils'

export function Header() {
  const { user } = useAuthStore()
  const { theme, toggleTheme } = useThemeStore()
  const { toggleSidebar, toggleSidebarMini, sidebarMini } = useUIStore()

  return (
    <header className="sticky top-0 z-30 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl border-b border-slate-200 dark:border-slate-800">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Left */}
        <div className="flex items-center gap-4">
          {/* Mobile Menu Toggle */}
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleSidebar}
            className="lg:hidden"
          >
            <Menu className="w-5 h-5" />
          </Button>

          {/* Desktop Sidebar Collapse Toggle */}
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleSidebarMini}
            className="hidden lg:flex text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100"
            title={sidebarMini ? "展开菜单" : "收起菜单"}
          >
            <PanelLeft className={cn('w-5 h-5 transition-transform duration-200', sidebarMini && 'rotate-180')} />
          </Button>

          <div className="hidden md:flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400">
            <Search className="w-4 h-4" />
            <input
              type="text"
              placeholder="搜索..."
              className="bg-transparent border-none outline-none text-sm w-48 placeholder:text-slate-400"
            />
          </div>
        </div>

        {/* Right */}
        <div className="flex items-center gap-2">
          {/* Theme Toggle */}
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            className="relative"
          >
            {theme === 'dark' ? (
              <Moon className="w-5 h-5" />
            ) : (
              <Sun className="w-5 h-5" />
            )}
          </Button>

          {/* Notifications */}
          <Button variant="ghost" size="icon" className="relative">
            <Bell className="w-5 h-5" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-rose-500 rounded-full" />
          </Button>

          {/* User */}
          <div className="flex items-center gap-3 pl-4 border-l border-slate-200 dark:border-slate-800">
            <div className="text-right hidden md:block">
              <p className="text-sm font-medium text-slate-900 dark:text-white">
                {user?.full_name || user?.username}
              </p>
              <p className="text-xs text-slate-500 dark:text-slate-400">
                {user?.department || '未分配部门'}
              </p>
            </div>
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-medium">
              {user?.avatar ? (
                <img src={user.avatar} alt={user.full_name} className="w-full h-full rounded-full" />
              ) : (
                <User className="w-5 h-5" />
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
